import {client as http, axiosInstance} from "@/http_client";
import async from "async";

export default {
    state: {
        enrollments: null
    },
    getters: {
        enrollments: state => state.enrollments
    },
    mutations: {},
    actions: {
        getEnrollments({state}) {
            return new Promise((resolve, reject) => {
                http.get('app/enrollments/', {force: true}).then(response => {
                    state.enrollments = response.data.enrollments;
                    resolve(state.enrollments);
                }).catch(err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },
    }
};
